var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9377_79254)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.25 0H24.25V24H0.25V0Z",
    fill: "#012169"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.25 0V3L15.3438 12L24.25 20.7656V24H21.1094L12.1562 15.1875L3.4375 24H0.25V20.8125L8.96875 12.0469L0.25 3.46875V0H3.15625L12.1562 8.8125L20.875 0H24.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.875 15.1875L9.39062 16.7812L2.21875 24H0.25V23.8594L8.875 15.1875ZM14.6875 14.625L17.2188 15L24.25 21.8906V24L14.6875 14.625ZM24.25 0L15.25 9.1875L15.0625 7.125L22.0938 0H24.25ZM0.25 0.046875L9.29688 8.90625L6.53125 8.53125L0.25 2.29688V0.046875Z",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 0V24H16V0H8.5ZM0.25 8.25V15.75H24.25V8.25H0.25Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.25 9.75V14.25H24.25V9.75H0.25ZM10 0V24H14.5V0H10Z",
    fill: "#C8102E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9377_79254"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    width: 24,
    height: 24,
    rx: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEn);
export default __webpack_public_path__ + "static/media/en.4a6af350e6ca7b9386acd5a3e29eb2b5.svg";
export { ForwardRef as ReactComponent };